import { render, staticRenderFns } from "./PerformersSidesheet.vue?vue&type=template&id=72943708&scoped=true&"
import script from "./PerformersSidesheet.vue?vue&type=script&lang=js&"
export * from "./PerformersSidesheet.vue?vue&type=script&lang=js&"
import style0 from "./PerformersSidesheet.vue?vue&type=style&index=0&id=72943708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72943708",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72943708')) {
      api.createRecord('72943708', component.options)
    } else {
      api.reload('72943708', component.options)
    }
    module.hot.accept("./PerformersSidesheet.vue?vue&type=template&id=72943708&scoped=true&", function () {
      api.rerender('72943708', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/functions/function/information/components/PerformersSidesheet.vue"
export default component.exports